import { accountNumberQuery } from './middleware-patient-services-utils';

export const fetchUserAccountNumber = async (sessionValue?: string) => {
	const APP_NAME = process.env.APP_NAME;
	const EAPI_GRAPHQL_URL = process.env.EAPI_GRAPHQL_URL;

	try {
		const userAccountFetchResponse = await fetch(EAPI_GRAPHQL_URL, {
			method: 'POST',
			headers: {
				Cookie: `aspendental_session=${sessionValue}`,
				'Content-Type': 'application/json',
				'x-client-application': APP_NAME,
			},
			credentials: 'include',
			body: JSON.stringify({ query: accountNumberQuery, operationName: 'getAccountNumber' }),
		});

		return await userAccountFetchResponse.json();
	} catch {
		throw new Error('Failed to verify session token');
	}
};
